module.exports = __webpack_public_path__ + "img/help.c38d83e3.png";